import React from "react";
import { Mail, FileText, Star } from "lucide-react";
import ApplicationTags from "./applicationviewcomponents/ApplicationTags";
import ApplicationFields from "./applicationviewcomponents/ApplicationFields";
import ApplicationHistory from "./applicationviewcomponents/ApplicationHistory";
import CandidateCV from "./applicationviewcomponents/CandidateCV";
import JobDetail from "./applicationviewcomponents/JobDetail";
// import CandidateNotes from "./applicationviewcomponents/CandidateNotes";
import useAuth from "@/hooks/stores/useAuth";

function ApplicationView({
  direction = "",
  currentApplication,
  currentVacancy,
  tagsPerApplication,
  showCV,
  onToggleCV,
  onShowHistory,
  // quickSaveChild = null,
  // currentNotes,
}) {
  const { currentUser } = useAuth();

  const getAnimationClasses = () => {
    if (!direction) return "";
    return `${direction === "left" ? "-translate-x-full opacity-0" : ""} 
            ${direction === "right" ? "translate-x-full opacity-0" : ""}`;
  };

  return (
    <div className="flex gap-6 w-full mb-16">
      {/* Personal Information */}
      <div className="w-1/4">
        <div
          className={`bg-card rounded-xl  overflow-hidden transform transition-all duration-300 ${getAnimationClasses()}`}
        >
          <div className="bg-muted text-primary-dark p-6">
            <h2 className="text-3xl font-bold text-foreground mb-3 flex items-center overflow-hidden">
              {currentUser?.user?.name || "Not Found"}
              {currentApplication?.priority > 0 && (
                <span className="text-yellow-400 ml-2 flex items-center">
                  <Star className="w-4 h-4" fill="currentColor" />
                </span>
              )}
            </h2>

            <ApplicationTags
              tags={(tagsPerApplication[currentApplication?.id] || []).map(
                (tag) => (typeof tag === "string" ? tag : tag?.name || tag),
              )}
            />
          </div>

          <div className="p-6 space-y-6">
            <ApplicationFields
              applicationFields={currentApplication?.application_fields}
              customFields={currentVacancy?.custom_fields?.personal ?? []}
            />

            {/* Contact Section */}
            <div className="bg-card rounded-lg border border-border p-3">
              <div className="space-y-3">
                <div className="flex items-center gap-2 text-foreground break-words">
                  <Mail className="w-5 h-5" />
                  <span className="break-all">{currentUser?.user?.email}</span>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="space-y-3">
              {currentApplication?.application_fields?.map((field, index) => {
                if (
                  field.field_type === "file" &&
                  field.form_type === "personal"
                ) {
                  return (
                    <button
                      key={index}
                      onClick={() => window.open("#", "_blank")}
                      className="w-full bg-[#7ecfae] hover:bg-primary-dark text-white py-3 px-6 rounded-lg shadow-md transition-colors duration-200 flex items-center justify-center gap-2"
                    >
                      <FileText className="w-5 h-5" />
                      View {field.field_name}
                    </button>
                  );
                }
                return null;
              })}
            </div>
          </div>
        </div>
      </div>

      {/* CV and Job Details */}
      <div className="w-3/4">
        <div
          className={`transform transition-all duration-300 ${getAnimationClasses()}`}
        >
          <JobDetail
            showCV={showCV}
            onToggleView={onToggleCV}
            resumeEnabled={currentVacancy?.resume_enable === 1}
            cvUrl={currentApplication?.resume}
          >
            <CandidateCV
              showCV={showCV}
              cvUrl={currentApplication?.resume}
              coverLetter={currentApplication?.cover_letter}
              applicationFields={currentApplication?.application_fields}
              coverLetterEnabled={currentVacancy?.cover_letter_enable === 1}
            />
          </JobDetail>
        </div>
        {showCV && currentApplication?.resume && (
          <div className="mt-6">
            <a
              href={currentApplication?.resume}
              download
              className="inline-block px-4 py-2 bg-primary-dark hover:bg-primary-dark text-white rounded-lg transition-colors w-full text-center"
            >
              Download CV
            </a>
          </div>
        )}
      </div>

      {/* Recruiter Notes */}
      {/* <div className="w-1/4">
        <div
          className={`rounded-xl overflow-hidden  transition-all duration-300 ${getAnimationClasses()}`}
        >
          <CandidateNotes
            key={currentApplication?.id}
            applicationId={currentApplication?.id}
            candidateId={
              currentApplication?.candidate?.id ||
              currentApplication?.candidate_id
            }
            notes={currentNotes || currentApplication?.application_notes || []}
          />
          {quickSaveChild && quickSaveChild({ className: "mt-4" })}
        </div>
      </div> */}
    </div>
  );
}

export default ApplicationView;
